import { Card } from "flowbite-react";
import { IoIosLock } from "react-icons/io";

const ForbiddenQueriesPermission = () => {
  return (
    <Card className="flex items-center justify-center p-2 w-full">
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="bg-red-100 p-4 rounded-full">
          <IoIosLock className="w-10 h-10 text-red-500" />
        </div>
        <h2 className="text-2xl font-bold text-gray-800">Acesso negado</h2>
        <p className="text-gray-600">
          Você{" "}
          <span className="text-red-500 font-semibold">não tem permissão</span>{" "}
          para acessar este recurso. Verifique com o administrador do sistema.
        </p>
        <button
          onClick={() => window.history.back()}
          className="mt-4 px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg transition"
        >
          Voltar
        </button>
      </div>
    </Card>
  );
};

export default ForbiddenQueriesPermission;
